export enum ProductName {
  CLASSIC = 'Classic',
  GOLD = 'Gold',
  GOLD_PLUS = 'Gold Plus',
  BLACK = 'Black',
  PLATINUM = 'Platinum',
}
